import React from "react";
import Hero from "../components/sections/Hero";
import NeuchatelLocal from "../components/sections/NeuchatelLocal";
import Solutions from "../components/sections/Solutions";
import KioskSpotlight from "../components/sections/KioskSpotlight";
import Industries from "../components/sections/Industries";
import PaymentMethods from "../components/sections/PaymentMethods";
import CompareCTA from "../components/sections/CompareCTA";
import DemoRequest from "../components/sections/DemoRequest";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <NeuchatelLocal />
      <Solutions />
      <KioskSpotlight />
      <Industries />
      <PaymentMethods />
      <CompareCTA />
      <DemoRequest />
    </div>
  );
}
